import { StepperField } from "../parts/StepperField";

// ═══════════════════════════════════════════════════════════════════════════
// STEP: Temel Bilgiler
// ═══════════════════════════════════════════════════════════════════════════
// `requiredBodyFields` içinde "height" varsa — bu ürün tablosu `product_length`,
// `product_sleeve` veya `product_inseam` barındırıyor demektir ve algoritma
// ürün uzunluğunu kullanıcı boyuyla eşlemek için boyu kritik şekilde kullanır.
// Bu durumda Boy label'ının yanına küçük bir "zorunlu" uyarı rozeti çıkarırız;
// kullanıcı niye boyu doldurmanın bu üründe değer kattığını hissetsin diye.
// Boy her üründe zaten (BMI tahmini için) soruluyor ve değersiz Devam
// edilemiyor; ancak `product_length`'li ürünlerde bu özellikle vurgulanır.
export const BasicInfoStep = ({ profile, setField, copy, accent, requiredBodyFields }) => {
    const missingFields = [];
    if (!profile.height) missingFields.push("Boy");
    if (!profile.weight) missingFields.push("Kilo");
    if (!profile.age) missingFields.push("Yaş");
    const heightCritical = Array.isArray(requiredBodyFields) && requiredBodyFields.includes("height");
    return (
        <div className="space-y-6" data-testid="fms-step-basic">
            <div>
                <h3 className="text-[24px] font-bold text-foreground tracking-tight leading-tight">
                    {copy.basicTitle || "Seni tanıyalım"}
                </h3>
                <p className="text-[13.5px] text-muted-foreground mt-2 leading-relaxed">
                    {copy.basicDesc || "Boy, kilo ve yaşın en doğru bedeni bulmak için yeterli. Ölçü sormuyoruz."}
                </p>
            </div>
            {/* Tek sütun — Fit adımının DNA'sıyla birebir aynı: p-4 padding, iki satır
                text (label + hint), sağda minimal interactive. Mobilde ferah, masaüstünde
                modali dengeli doldurur. */}
            <div className="space-y-2.5">
                <StepperField
                    label="Boy"
                    unit="cm"
                    hint={heightCritical ? "Bu üründe ürün uzunluğu için kritik — ayakkabısız" : "Ayakkabısız, en yakın cm"}
                    min={140}
                    max={210}
                    step={1}
                    value={profile.height}
                    onChange={(v) => setField("height", v)}
                    accent={accent}
                    testId="fms-input-height"
                    delayMs={0}
                    requiredBadge={heightCritical}
                />
                <StepperField label="Kilo" unit="kg" hint="Günlük ortalama kilon" min={35} max={200} step={1} value={profile.weight} onChange={(v) => setField("weight", v)} accent={accent} testId="fms-input-weight" delayMs={60} />
                <StepperField label="Yaş" unit="yıl" hint="Vücut değişimini yansıtır" min={16} max={90} step={1} value={profile.age} onChange={(v) => setField("age", v)} accent={accent} testId="fms-input-age" delayMs={120} />
            </div>
            {missingFields.length > 0 && (
                <p
                    className="text-[12px] text-destructive leading-snug"
                    data-testid="fms-basic-missing-hint"
                    role="alert"
                >
                    {missingFields.length === 1
                        ? `Devam etmek için ${missingFields[0]} alanını doldur.`
                        : `Devam etmek için ${missingFields.join(", ")} alanlarını doldur.`}
                </p>
            )}
        </div>
    );
};
